import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Option } from '../../../dropdowns/models/option.model';
import { FieldBase } from '../field-base.class';

@Component({
  selector: 'cs-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownComponent extends FieldBase {

  /** Options list that will be rendered in the dropdown. */
  @Input() list: Option[];

  constructor() { 
    super();
  }

  /** By default, inputClass is 'form-control form-control-sm'. */
  setDefaultInputClass(): string {
    return "form-control form-control-sm";
  }

}
